import styled, { css } from 'styled-components/macro';
import { getItemAnimation } from 'styles/animations.styled';

export const Wrapper = styled.div<{
  hovered: boolean;
  selected: boolean;
  collapsed: boolean;
  canCollapsed: boolean;
  isDisabled: boolean;
}>`
  display: ${(props) =>
    props.collapsed ? (props.selected ? 'block' : 'none') : 'block'};
  animation-name: ${(props) => getItemAnimation(props.collapsed)};
  animation-delay: 0s;
  animation-duration: 300ms;
  background-color: ${(props) =>
    props.isDisabled
      ? '#F2F5F8'
      : !props.collapsed &&
          (props.hovered || (props.selected && props.canCollapsed))
        ? '#f2f5f8'
        : ''};
  opacity: ${(props) => (props.collapsed ? (props.selected ? '1' : '0') : '1')};
  padding: 12px;
  border-radius: 12px;
  border: 1px solid
    ${(props) =>
      props.selected && (props.collapsed || !props.canCollapsed)
        ? '#697180'
        : 'transparent'};
  box-shadow:
    0 1px 2px 0 rgba(15, 23, 40, 0.04),
    0 1px 3px 0 rgba(15, 23, 40, 0.12),
    0 0 8px 4px rgba(15, 23, 40, 0.04);
  transition: all 150ms;

  div,
  span {
    ${(props) =>
      props.isDisabled &&
      css`
        color: ${props.theme.colors.gray[400]} !important;
        pointer-events: none;
      `}
  }
`;

export const UpperBlock = styled.div<{ collapsed: boolean }>`
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: ${(props) => (props.collapsed ? 'default' : 'pointer')};
`;

export const PositionWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

export const PositionSpan = styled.span`
  color: #495466;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;

export const PositionDivider = styled.div`
  width: 1px;
  background-color: #868f9e;
`;

export const BottomBlock = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Status = styled.div<{ isResponsibility: boolean }>`
  background-color: ${(props) =>
    props.isResponsibility ? '#dbfbe6' : '#e0eeff'};
  padding: 4px 8px;
  border-radius: 100px;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
`;
